import React from "react";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import FooterCenter from "../../components/footer/FooterCenter";
import FooterRight from "../../components/footer/FooterRight";
import FooterLeft from "../../components/footer/FooterLeft";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    padding: "5em 10em",
    backgroundColor: "#F4F4F4",
    margin: "auto auto",
    boxSizing: "border-Box",
    justifyContent: "space-around",
    alignContent: "center",
    [theme.breakpoints.down("sm")]: {
      padding: "1.5em 0",
      justifyContent: "space-between",
    },
    footerRight: {
      [theme.breakpoints.down("sm")]: {
        marginTop: "10%",
      },
    },
  },
}));

const Footer = () => {
  const classes = useStyles();
  return (
    <Grid spacing={3} className={classes.root} container>
      <Grid item>
        <FooterLeft />
      </Grid>
      <Grid item>
        <FooterCenter />
      </Grid>
      <Grid item>
        <FooterRight lg />
      </Grid>
    </Grid>
  );
};

export default Footer;
